import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { OperationStatusIconsWrapper } from '../OperationListView.styles';
import { HighlightCargoes } from '../../rotationView/RotationView.styles';
import { CargoOperationInfoMenu } from '../../Stowage.styles';
import { RotationCargoOperation } from 'src/types/ViewModel/Stowage/Rotation/RotationCargoOperation';
import ViolationListIconComponent from '../../violationListView/ViolationListIcon';
import { isManualCargoOperation } from 'src/utils/stowage/cargoOperationUtils';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import SequenceChangedIcon from 'src/components/ui/status-icon/SequenceChangedIcon';

interface OperationStatusIconsProps {
    cargoOperation: RotationCargoOperation;
    violationType: StowageRuleConsequenceType | null;
    onOpenOperationMenu: (e: React.MouseEvent) => void;
    onViewCargoOperation: (cargoOperation: RotationCargoOperation) => void;
    onViewViolationsForCargo: () => void;
    getOperationStatusIcon: () => JSX.Element | undefined;
}

export const OperationStatusIcons: React.FC<OperationStatusIconsProps> = ({
    cargoOperation,
    violationType,
    onOpenOperationMenu,
    onViewCargoOperation,
    onViewViolationsForCargo,
    getOperationStatusIcon,
}) => (
    <OperationStatusIconsWrapper>
        <span className="status-icon-column operation-menu-icon">
            <CargoOperationInfoMenu onClick={(e) => onOpenOperationMenu(e)} title="Open cargo operation menu">
                <FontAwesomeIcon icon="ellipsis-h" />
            </CargoOperationInfoMenu>
        </span>
        <span className="status-icon-column">{getOperationStatusIcon()}</span>
        <span className="status-icon-column">
            <HighlightCargoes onClick={() => onViewCargoOperation(cargoOperation)} title="Highlight cargo">
                <FontAwesomeIcon icon="eye" />
            </HighlightCargoes>
        </span>
        <span className="status-icon-column" onClick={onViewViolationsForCargo}>
            <ViolationListIconComponent violationType={violationType} includeText={false} />
        </span>
        <span className="status-icon-column">
            {isManualCargoOperation(cargoOperation) && (
                <span title="Manual cargo operation" className="manual-node-marker">
                    M
                </span>
            )}
        </span>
        <span className="status-icon-column">
            <SequenceChangedIcon hasChangedSequence={cargoOperation.hasChangedSequence} />
        </span>
        <span className="status-icon-column">
            {cargoOperation.cargo.comment && (
                <span title={cargoOperation.cargo.comment} className="comment-icon">
                    <FontAwesomeIcon icon="comment" />
                </span>
            )}
        </span>
    </OperationStatusIconsWrapper>
);

export default OperationStatusIcons;
